import React from 'react';
import { NavLink } from 'react-router-dom';

class HeaderMenu extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      show: false,
    };
  }
  handleClick = e => {
    this.setState({
      show: !this.state.show,
    });
  };
  render() {
    const { show } = this.state;
    return (
      <header>
        <section id='menu-logo'>
          <div className='container'>
            <div className='row'>
              <div className='col-md-12'>
                <nav className='navbar navbar-expand-lg navbar-light'>
                  <NavLink className='navbar-brand' to='/'>
                    <img src='./images/logo.svg' alt='' /> <span>Iaya</span>
                  </NavLink>
                  <button
                    className='navbar-toggler'
                    type='button'
                    data-toggle='collapse'
                    data-target='#navbarSupportedContent'
                    aria-controls='navbarSupportedContent'
                    aria-expanded='true'
                    aria-label='Toggle navigation'
                  >
                    <span
                      className='navbar-toggler-icon'
                      onClick={this.handleClick}
                    ></span>
                  </button>

                  <div
                    className={'navbar-collapse collapse'}
                    id='navbarSupportedContent'
                  >
                    <ul className='navbar-nav ml-auto nav-links '>
                      <li>
                        <NavLink
                          exact
                          className='nav-link'
                          activeClassName='active'
                          to='/'
                        >
                          Home
                        </NavLink>
                      </li>
                      <li>
                        <NavLink
                          className='nav-link'
                          activeClassName='active'
                          to='/bayans'
                        >
                          Bayaans
                        </NavLink>
                      </li>
                      <li>
                        <NavLink
                          className='nav-link'
                          activeClassName='active'
                          to='/dua'
                        >
                          Dua's
                        </NavLink>
                      </li>
                      <li>
                        <NavLink
                          className='nav-link'
                          activeClassName='active'
                          to='/publicEvents'
                        >
                          Events
                        </NavLink>
                      </li>
                      <li>
                        <NavLink
                          className='nav-link'
                          activeClassName='active'
                          to='/contact'
                        >
                          Contact
                        </NavLink>
                      </li>
                    </ul>
                  </div>
                </nav>
              </div>
            </div>
          </div>
        </section>
      </header>
    );
  }
}

export default HeaderMenu;
